module.exports = __webpack_public_path__ + "img/plug-short-left.56c1382e.svg";